import React, { forwardRef } from 'react';
import './ToggleSwitch.scss';

interface ToggleSwitchProps {
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  id?: string;
  className?: string;
  disabled?: boolean;
}

const ToggleSwitch = forwardRef<HTMLInputElement, ToggleSwitchProps>(
  ({ checked = false, onChange, id, className = '', disabled = false }, ref) => {
    return (
      <div className={`c-toggle-switch ${className}`}>
        <input
          ref={ref}
          type="checkbox"
          checked={checked}
          onChange={onChange}
          id={id}
          disabled={disabled}
          className="c-toggle-switch__input"
        />
        <label htmlFor={id} className="c-toggle-switch__label">
          <span className="c-toggle-switch__slider"></span>
        </label>
      </div>
    );
  }
);

ToggleSwitch.displayName = 'ToggleSwitch';

export default ToggleSwitch;
